import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PatientsService } from '../patients.service';
import { MediaTransferService } from '../media-transfer.service';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-media-transfer',
  templateUrl: './media-transfer.component.html',
  styleUrls: ['./media-transfer.component.scss'],
  standalone: false,
})
export class MediaTransferComponent implements OnInit {
  incorrectClinicControl = new FormControl();
  correctClinicControl = new FormControl();
  filteredIncorrectClinics: Observable<any[]>;
  filteredCorrectClinics: Observable<any[]>;

  constructor(
    public mts: MediaTransferService,
    public loginService: LoginService,
    public patientsService: PatientsService,
    public examService: ExamsService,
    private router: Router
  ) {
    this.loginService.loginMissing();
  }

  ngOnInit(): void {
    this.filteredIncorrectClinics = combineLatest([
      this.incorrectClinicControl.valueChanges.pipe(startWith('')),
      this.mts.availableClinics$,
    ]).pipe(map(([value, clinics]) => this.filterClinics(value, clinics)));

    this.filteredCorrectClinics = combineLatest([
      this.correctClinicControl.valueChanges.pipe(startWith('')),
      this.mts.availableClinics$,
    ]).pipe(map(([value, clinics]) => this.filterClinics(value, clinics)));
  }

  filterClinics(value: any, clinics: any[]): any[] {
    if (!value || typeof value !== 'string') {
      return clinics;
    }

    const filterValue = value.toLowerCase();
    return clinics.filter(
      (clinic) =>
        clinic.ClinicTitle.toLowerCase().includes(filterValue) ||
        clinic.GID.toString().includes(filterValue)
    );
  }

  displayClinic(clinic: any): string {
    return clinic ? `${clinic.GID} - ${clinic.ClinicTitle}` : '';
  }

  onIncorrectClinicSelected(clinic: any): void {
    if (clinic) {
      this.mts.selectedIncorrectClinic = clinic.GID;
    }
  }

  onCorrectClinicSelected(clinic: any): void {
    if (clinic) {
      this.mts.selectedCorrectClinic = clinic.GID;
    }
  }

  togglePopup() {
    this.mts.toggleSuccessMessage = !this.mts.toggleSuccessMessage;
  }

  exit() {
    this.router.navigateByUrl('/patsearch');
  }
}
